import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const translations = {
  fr: {
    // Navbar
    nav_home: "Accueil",
    nav_programs: "Programmes",
    nav_lexicon: "Lexique IA",
    nav_chat: "Assistant IA",
    nav_dashboard: "Tableau de bord",
    nav_login: "Connexion",
    nav_register: "Inscription",
    nav_logout: "Déconnexion",
    nav_profile: "Profil",
    
    // Landing
    hero_title: "Gagnez 1h par jour grâce à l'IA, même sans aucune compétence technique.",
    hero_subtitle: "La formation IA la plus complète en français et en anglais. Du débutant au leader, 4 programmes, assistant IA intégré, certificats reconnus.",
    hero_cta: "Commencer gratuitement",
    hero_explore: "Voir les programmes",
    features_title: "Ce qui nous rend unique",
    feat_1_title: "4 formats flexibles",
    feat_1_desc: "1h, 2h+4h, 8h ou tous les modules : choisissez selon votre planning. Pas de contrainte horaire.",
    feat_2_title: "Assistant IA Claude intégré",
    feat_2_desc: "Posez vos questions en temps réel à un expert IA. Réponses instantanées et personnalisées.",
    feat_3_title: "9 quiz + certificats",
    feat_3_desc: "Validez chaque étape avec des quiz notés. Obtenez des certificats partageables sur LinkedIn.",
    feat_4_title: "Lexique de 15+ outils IA",
    feat_4_desc: "ChatGPT, Claude, Midjourney, Copilot... Maîtrisez chaque outil avec des exemples concrets.",
    programs_preview: "Nos Programmes de Formation",
    target_title: "Une formation pour chaque profil",
    target_students: "Lycéens et étudiants",
    target_pros: "Professionnels en activité",
    target_leaders: "Dirigeants et managers",
    target_beginners: "Débutants curieux",
    
    // Auth
    login_title: "Connexion",
    register_title: "Créer un compte",
    email_label: "Email",
    password_label: "Mot de passe",
    name_label: "Nom complet",
    login_btn: "Se connecter",
    register_btn: "Créer mon compte",
    google_btn: "Continuer avec Google",
    or_divider: "ou",
    no_account: "Pas encore de compte ?",
    has_account: "Déjà un compte ?",
    
    // Dashboard
    dash_title: "Tableau de bord",
    dash_welcome: "Bienvenue",
    dash_progress: "Votre progression",
    dash_continue: "Continuer l'apprentissage",
    dash_modules_done: "Modules terminés",
    dash_quizzes_done: "Quiz réalisés",
    dash_avg_score: "Score moyen",
    dash_no_progress: "Commencez votre première formation !",
    
    // Programs
    programs_title: "Programmes de Formation",
    programs_subtitle: "Choisissez le format qui vous convient le mieux",
    duration: "Durée",
    level: "Niveau",
    modules: "modules",
    start_program: "Commencer",
    continue_program: "Continuer",
    beginner: "Débutant",
    intermediate: "Intermédiaire",
    advanced: "Avancé",
    target: "Public cible",
    
    // Course
    course_content: "Contenu du cours",
    course_complete: "Marquer comme terminé",
    course_completed: "Terminé",
    course_next: "Module suivant",
    course_prev: "Module précédent",
    course_quiz: "Passer le quiz",
    
    // Lexicon
    lexicon_title: "Lexique IA",
    lexicon_subtitle: "Tous les outils IA essentiels expliqués simplement",
    lexicon_search: "Rechercher un outil...",
    lexicon_all: "Tous",
    lexicon_example: "Exemple",
    lexicon_visit: "Visiter le site",
    
    // Chat
    chat_title: "Assistant IA",
    chat_subtitle: "Posez vos questions sur l'IA à notre expert",
    chat_placeholder: "Posez votre question sur l'IA...",
    chat_send: "Envoyer",
    chat_welcome: "Bonjour ! Je suis votre assistant IA. Posez-moi n'importe quelle question sur l'intelligence artificielle.",
    chat_rate: "Noter cette réponse",
    
    // Quiz
    quiz_title: "Quiz",
    quiz_question: "Question",
    quiz_of: "sur",
    quiz_submit: "Valider mes réponses",
    quiz_score: "Votre score",
    quiz_correct: "Bonne réponse !",
    quiz_wrong: "Réponse incorrecte",
    quiz_retry: "Recommencer",
    quiz_back: "Retour au cours",
    quiz_explanation: "Explication",
    
    // Certificates
    cert_title: "Mes Certificats",
    cert_subtitle: "Vos certifications obtenues",
    cert_generate: "Obtenir le certificat",
    cert_download: "Télécharger",
    cert_share: "Partager",
    cert_share_title: "Partager votre certificat",
    cert_copy_link: "Copier le lien",
    cert_copied: "Lien copié !",
    cert_no_certs: "Aucun certificat pour le moment. Complétez un programme pour en obtenir un !",
    cert_awarded: "Certificat décerné à",
    cert_completed: "a complété avec succès la formation",
    cert_score: "Score obtenu",
    cert_date: "Date d'obtention",
    cert_verify: "Vérifier ce certificat",
    cert_share_text: "J'ai obtenu mon certificat IA Academy !",
    cert_congrats: "Félicitations !",
    cert_program_complete: "Vous avez terminé le programme",
    cert_view: "Voir le certificat",
    cert_share_on: "Partager sur",
    nav_certificates: "Certificats",
    
    // Pricing
    pricing_title: "Des tarifs adaptés à vos ambitions",
    pricing_subtitle: "Investissez dans votre avenir. Des formations IA accessibles et premium.",
    pricing_free: "Gratuit",
    pricing_standard: "Standard",
    pricing_premium: "Premium",
    pricing_month: "/mois",
    pricing_once: "paiement unique",
    pricing_current: "Plan actuel",
    pricing_upgrade: "Choisir ce plan",
    pricing_popular: "Le plus populaire",
    pricing_payment_success: "Paiement réussi !",
    pricing_payment_processing: "Vérification du paiement...",
    pricing_activated: "Votre plan a été activé avec succès.",
    pricing_go_dashboard: "Aller au tableau de bord",
    pricing_requires_premium: "Cette fonctionnalité nécessite un plan Pro ou supérieur",
    nav_pricing: "Tarifs",

    // General
    loading: "Chargement...",
    error: "Une erreur est survenue",
    back: "Retour",
    save: "Enregistrer",
    cancel: "Annuler",
    search: "Rechercher",
    all: "Tous",
    language: "Langue",

    // Streaks
    streak_title: "Votre Série",
    streak_days: "jours",
    streak_day: "jour",
    streak_active_today: "Actif aujourd'hui",
    streak_not_active: "Pas encore actif",
    streak_freeze: "Gel de série",
    streak_freeze_used: "Gel utilisé cette semaine",
    streak_max: "Record",
    streak_total: "Jours actifs",
    streak_keep_going: "Continuez votre série !",
    streak_start: "Commencez une série d'apprentissage !",

    // Adaptive Quiz
    quiz_adaptive: "Quiz Adaptatif",
    quiz_level: "Votre niveau",
    quiz_level_beginner: "Débutant",
    quiz_level_intermediate: "Intermédiaire",
    quiz_level_advanced: "Avancé",
    quiz_adaptive_mode: "Mode adaptatif",
    quiz_standard_mode: "Mode standard",
    quiz_difficulty: "Difficulté",
  },
  en: {
    nav_home: "Home",
    nav_programs: "Programs",
    nav_lexicon: "AI Lexicon",
    nav_chat: "AI Assistant",
    nav_dashboard: "Dashboard",
    nav_login: "Log in",
    nav_register: "Sign up",
    nav_logout: "Log out",
    nav_profile: "Profile",
    
    hero_title: "Save 1 hour a day with AI, even with zero technical skills.",
    hero_subtitle: "The most comprehensive AI training in French & English. From beginner to leader, 4 programs, built-in AI assistant, recognized certificates.",
    hero_cta: "Start for Free",
    hero_explore: "View Programs",
    features_title: "What Makes Us Unique",
    feat_1_title: "4 Flexible Formats",
    feat_1_desc: "1h, 2h+4h, 8h or all modules: choose based on your schedule. No time constraints.",
    feat_2_title: "Built-in Claude AI Assistant",
    feat_2_desc: "Ask questions in real-time to an AI expert. Instant, personalized answers.",
    feat_3_title: "9 Quizzes + Certificates",
    feat_3_desc: "Validate each step with graded quizzes. Get shareable certificates for LinkedIn.",
    feat_4_title: "15+ AI Tools Lexicon",
    feat_4_desc: "ChatGPT, Claude, Midjourney, Copilot... Master each tool with concrete examples.",
    programs_preview: "Our Training Programs",
    target_title: "A Training for Every Profile",
    target_students: "Students",
    target_pros: "Working Professionals",
    target_leaders: "Executives & Managers",
    target_beginners: "Curious Beginners",
    
    login_title: "Log In",
    register_title: "Create Account",
    email_label: "Email",
    password_label: "Password",
    name_label: "Full Name",
    login_btn: "Log In",
    register_btn: "Create Account",
    google_btn: "Continue with Google",
    or_divider: "or",
    no_account: "Don't have an account?",
    has_account: "Already have an account?",
    
    dash_title: "Dashboard",
    dash_welcome: "Welcome",
    dash_progress: "Your Progress",
    dash_continue: "Continue Learning",
    dash_modules_done: "Modules Completed",
    dash_quizzes_done: "Quizzes Completed",
    dash_avg_score: "Average Score",
    dash_no_progress: "Start your first training!",
    
    programs_title: "Training Programs",
    programs_subtitle: "Choose the format that suits you best",
    duration: "Duration",
    level: "Level",
    modules: "modules",
    start_program: "Start",
    continue_program: "Continue",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    target: "Target Audience",
    
    course_content: "Course Content",
    course_complete: "Mark as Complete",
    course_completed: "Completed",
    course_next: "Next Module",
    course_prev: "Previous Module",
    course_quiz: "Take the Quiz",
    
    lexicon_title: "AI Lexicon",
    lexicon_subtitle: "All essential AI tools explained simply",
    lexicon_search: "Search a tool...",
    lexicon_all: "All",
    lexicon_example: "Example",
    lexicon_visit: "Visit Website",
    
    chat_title: "AI Assistant",
    chat_subtitle: "Ask our expert your questions about AI",
    chat_placeholder: "Ask your question about AI...",
    chat_send: "Send",
    chat_welcome: "Hello! I'm your AI assistant. Ask me anything about artificial intelligence.",
    chat_rate: "Rate this response",
    
    quiz_title: "Quiz",
    quiz_question: "Question",
    quiz_of: "of",
    quiz_submit: "Submit Answers",
    quiz_score: "Your Score",
    quiz_correct: "Correct!",
    quiz_wrong: "Incorrect",
    quiz_retry: "Try Again",
    quiz_back: "Back to Course",
    quiz_explanation: "Explanation",
    
    cert_title: "My Certificates",
    cert_subtitle: "Your earned certifications",
    cert_generate: "Get Certificate",
    cert_download: "Download",
    cert_share: "Share",
    cert_share_title: "Share Your Certificate",
    cert_copy_link: "Copy Link",
    cert_copied: "Link copied!",
    cert_no_certs: "No certificates yet. Complete a program to earn one!",
    cert_awarded: "Certificate awarded to",
    cert_completed: "has successfully completed the training",
    cert_score: "Score achieved",
    cert_date: "Date awarded",
    cert_verify: "Verify this certificate",
    cert_share_text: "I just earned my IA Academy certificate!",
    cert_congrats: "Congratulations!",
    cert_program_complete: "You have completed the program",
    cert_view: "View Certificate",
    cert_share_on: "Share on",
    nav_certificates: "Certificates",
    
    pricing_title: "Pricing Adapted to Your Ambitions",
    pricing_subtitle: "Training programs adapted to all budgets",
    pricing_free: "Free",
    pricing_standard: "Standard",
    pricing_premium: "Premium",
    pricing_month: "/month",
    pricing_once: "one-time payment",
    pricing_current: "Current Plan",
    pricing_upgrade: "Choose This Plan",
    pricing_popular: "Most Popular",
    pricing_payment_success: "Payment Successful!",
    pricing_payment_processing: "Verifying payment...",
    pricing_activated: "Your plan has been activated successfully.",
    pricing_go_dashboard: "Go to Dashboard",
    pricing_requires_premium: "This feature requires a Pro plan or higher",
    nav_pricing: "Pricing",

    loading: "Loading...",
    error: "An error occurred",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    search: "Search",
    all: "All",
    language: "Language",

    // Streaks
    streak_title: "Your Streak",
    streak_days: "days",
    streak_day: "day",
    streak_active_today: "Active today",
    streak_not_active: "Not active yet",
    streak_freeze: "Streak Freeze",
    streak_freeze_used: "Freeze used this week",
    streak_max: "Record",
    streak_total: "Active days",
    streak_keep_going: "Keep your streak going!",
    streak_start: "Start a learning streak!",

    // Adaptive Quiz
    quiz_adaptive: "Adaptive Quiz",
    quiz_level: "Your level",
    quiz_level_beginner: "Beginner",
    quiz_level_intermediate: "Intermediate",
    quiz_level_advanced: "Advanced",
    quiz_adaptive_mode: "Adaptive mode",
    quiz_standard_mode: "Standard mode",
    quiz_difficulty: "Difficulty",
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('app_language') || 'fr';
  });

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations['fr']?.[key] || key;
  }, [language]);

  const switchLanguage = useCallback((lang) => {
    setLanguage(lang);
    localStorage.setItem('app_language', lang);
  }, []);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
